import React from 'react'

const ProgressContext = React.createContext({})
export const ProgressProvider = ProgressContext.Provider
export default ProgressContext